import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { CurrentSelection } from '../Context/GarmentContext/GarmentContext';
import { LoggingContext } from '../Context/LoggingContext/LoggingContext';

const measureTypesObject = {
  xs: ['xs-short', 'xs', 'xs standard', 'xs-long'],
  small: ['s-short', 'sm', 'small', 's', 's standard', 's-long'],
  medium: [
    'm short',
    'm-short',
    'medium',
    'md',
    'm',

    'm standard',
    'm-standard',
    'm long',
    'm-long',
  ],
  large: ['l short', 'l-short', 'lg', 'large', 'l', 'l standard', 'l-standard', 'l-long', 'l long'],
  xl: ['xl-short', 'xl', 'extra large', 'x-large', 'xl standard', 'xl-long', 'xl long'],
  xxl: ['2xl short', 'xxl', '2xl', '2xl standard', '2xl long'],
  '3xl': ['xxxl', '3xl', '3xl standard', '3xl long'],
  '4xl': ['xxxxl', '4xl', '4xl standard', '4xl long'],
  '5xl': ['xxxxxl', '5xl', '5xl standard'],
  'N/A': [],
};

const flattenedArray = Object.keys(measureTypesObject).reduce((acc, cur) => {
  const thisArray = measureTypesObject[cur as keyof typeof measureTypesObject];
  return acc.concat(thisArray);
}, [] as string[]);

function sortSizes(mixedSizes: string[]):string[]{
  return mixedSizes.sort((a, b) => {
    const aIndex = flattenedArray.findIndex((element)=> element === a);
    const bIndex = flattenedArray.findIndex((element)=> element === b);
    if (aIndex > bIndex) return 1;
    return -1
})
}

function SizeDropdown({
  value,
  setValue,
  values,
  label,
}: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<CurrentSelection>>;
  values: string[];
  label: string;
}) {
  const location = useLocation();
  const { addLog } = useContext(LoggingContext);
  const handleChange = (event: SelectChangeEvent) => {
    setValue((prev) => ({ ...prev, [label]: event.target.value as string }));
  };
  return (
    <FormControl
      fullWidth
      sx={{ textDecoration: 'capitalize', maxWidth: '250px' }}
      size='small'
      onClick={() => addLog('clicked size dropdown on garment page', location.pathname)}
    >
      <InputLabel
        id={`${label}-select-label`}
        sx={{ textDecoration: 'capitalize', backgroundColor: 'white' }}
      >
        Select {label}
      </InputLabel>
      <Select
        labelId={`${label}-select-label`}
        id={`${label}-select`}
        value={value}
        label={label}
        onChange={handleChange}
        sx={{ textDecoration: 'capitalize' }}
      >
        {sortSizes(values).map((thisValue) => (
          <MenuItem key={thisValue} value={thisValue}>
            {thisValue}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SizeDropdown;
